"use client";

import Link from "next/link";

import { Text } from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { ArtDirection } from "@/components/util/art-direction";
import { Video } from "@/components/util/video";

import { useHero, UseHeroProps } from "./use-hero";

export type HeroProps = UseHeroProps;

function Hero(props: HeroProps) {
  const {
    className,
    styles,
    isVideoBackground,
    data: { title, description, cta, media, mediaCover },
    sectionName,
  } = useHero(props);

  return (
    <section className={styles.base({ className })} data-section-name={sectionName}>
      <div className={styles.wrapper()}>
        <div className={styles.hero()}>
          <div className={styles.content()}>
            <Text tag="h1" size="display3ExtraLarge" className={styles.title()}>
              {title}
            </Text>
            {description && (
              <Text tag="p" size="titleSmall" className={styles.description()}>
                {description}
              </Text>
            )}

            {cta &&
              cta.map((item) => (
                <Button
                  key={item.id}
                  className={styles.button()}
                  appearance={item.appearance}
                  color={item.color}
                  size={item.size}
                  rounded
                  asChild
                >
                  <Link href={item.url} target={item.newTab ? "_blank" : "_self"}>
                    {item.startIcon && <Icon name={item.startIcon} />}
                    {item.text}
                    {item.endIcon && <Icon name={item.endIcon} />}
                  </Link>
                </Button>
              ))}
          </div>

          <ArtDirection
            fill
            priority
            hiddenOn="md"
            className={styles.image()}
            containerClassName={styles.figure()}
            desktop={media}
          />
          {isVideoBackground && media && (
            <div className={styles.videoWrapper()}>
              <Video
                containerClassName={styles.videoContainer()}
                className={styles.video()}
                src={media?.url}
                mime={media?.mime}
                autoPlay
                muted
                loop
                playsInline
                poster={mediaCover?.url}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Hero;
